module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-5"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-5-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-5-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Shankill Road,")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Belfast, Northern Ireland")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("April 1970")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("J")]), _vm._v("im Bell made you fight your best friend.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("That’s what he did. That was his "), _c('i', [_vm._v("thing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stealing your dinner money or flicking your left testicle to leave you doubled over in agony weren’t enough for Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Oh no.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He wasn’t much to look at. Just a stringy lad, like the rest of them, in regulation grey jumper, shorts and crooked school tie.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But Jim was different. He had a capacity for an inventive cruelty beyond his years. A devious nature. An animal cunning that screwed up his face when he smiled and turned his eyes into slits. The kind of child who did bad things to insects and small birds for the benefit of an audience. He had authority amongst the other boys, because something of that malevolence had chillingly communicated itself. The implication that he would go further – might go all the way if it came to it – until he did something "), _c('i', [_vm._v("very ")]), _vm._v("wrong indeed. The children didn’t fully understand it, but they were afraid of it just the same.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("So when it was your turn, ‘Dinger’ Bell made you fight your best friend.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In front of what seemed like the whole school. Up a back alley, after lessons. It was either that or fight "), _c('i', [_vm._v("him")]), _vm._v(". And no-one wanted to do that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In the days running up to your ordeal, elaborate and clandestine choreography ensued. Best friends met secretly and practised.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Eban and his best mate, Stevie Burns, rehearsed their most plausible moves: half-kicks; feigned punches; full-body grappling; hair-tugging. Until they were adept and proficient in the art of pseudo-violence.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("All had to appear utterly authentic. Dinger knew when you were faking it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They had been friends since Primary Class 2. Batman and Robin, with duffle coats for capes. Hannibal Heyes and ‘Kid’ Curry on bikes for horses. Stevie was a strong lad, who had filled out early.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He could have beaten Eban in a fight any day of the week. Come to that, he could probably have taken Dinger Bell as well.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But as the boys were learning, in Belfast these days, it was no longer about how hard you were. But rather, how ‘mental’.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("So here they now were, circling each other menacingly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As their peers screamed for blood and Dinger looked on. Tight-closed lips stretched like an old hag’s smile.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They rolled around on the ground, perspiring with mock malice, grunting with real effort, whilst trying to avoid the stools and pellets of dog faeces that littered the back alley.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It usually finished in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("One or other of the combatants sat astride their adversary, pinning his arms down and dangling gob precariously over his face.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("If you were lucky, an adult might happen upon the ruction and all would flee, whooping and laughing. Or sometimes one of the girls would insist that it should stop or they’d tell.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But only if they liked you.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As Eban lay on his back panting, helplessly defeated, staring at the ribbon of sky above him, his mind turned to McGrew’s burned-out shell of a pub.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To an imagined land of solitude, seclusion and sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Wiping his face with the back of his sleeve, he silently resolved to find a way in there.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c730ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-005.vue
// module id = 90
// module chunks = 0